(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/bigstat-banner/assets/javascripts/bigstat-banner.js') >= 0) return;  svs.modules.push('/components/sportinfo/bigstat-banner/assets/javascripts/bigstat-banner.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect;
const logger = svs.core.log.getLogger('sport:sportinfo-bigstat-banner');
const SportinfoMatchState = svs.components.sportinfo.common.matchState.SportinfoMatchState;
const helpers = svs.components.sport.sportEventCommon.helpers;
const SportTypeToString = svs.components.sport.sportTypes.SportTypeToString;
const _svs$components$sport = svs.components.sportInfo.bigStatBanner,
  MatchHeader = _svs$components$sport.MatchHeader,
  MatchProgress = _svs$components$sport.MatchProgress;
const useSocket = svs.components.lbUtils.socket.useSocket;
const VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT = svs.components.lbUtils.cloudApi.cloudApiConstants.VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT;
const cloudSocket = svs.core.svsSocket.get('/v1/gameinfo-soc');
const productIds = svs.utils.products.productIds;
const _svs$ui = svs.ui,
  Icon = _svs$ui.ReactIcon,
  IconButton = _svs$ui.ReactIconButton;
const LiveDataSubscriber = _ref => {
  let path = _ref.path,
    onUpdate = _ref.onUpdate,
    matchId = _ref.matchId,
    productId = _ref.productId;
  const useCloudSocketApi = svs.core.detect.feature('ft-use-draw-proxy-sportevent-cloud-api') && VALID_PRODUCTS_FOR_CLOUD_ENDPOINT_SPORTEVENT.includes(productId);
  useEffect(() => {
    if (!matchId) {
      return undefined;
    }
    if (useCloudSocketApi) {
      const cloudPath = "/api/v1/sport/sportevents/".concat(matchId);
      const cloudHandler = response => {
        var _response$message;
        if (response !== null && response !== void 0 && (_response$message = response.message) !== null && _response$message !== void 0 && (_response$message = _response$message.data) !== null && _response$message !== void 0 && _response$message.sportEvent) {
          onUpdate({
            sportEvent: response.message.data.sportEvent,
            error: undefined
          });
        }
      };
      const drawSubscriptionCloud = cloudSocket.subscribe(cloudPath, cloudHandler, {
        sendInitialUpdate: false
      });
      return () => drawSubscriptionCloud.unsubscribe();
    }
  }, [matchId, productId, onUpdate, useCloudSocketApi]);
  useSocket(path, onUpdate, {
    skip: useCloudSocketApi
  });
  return null;
};
const BigStatBanner = _ref2 => {
  let homeTeam = _ref2.homeTeam,
    awayTeam = _ref2.awayTeam,
    leagueName = _ref2.leagueName,
    odds = _ref2.odds,
    matchState = _ref2.matchState,
    onCloseClick = _ref2.onCloseClick,
    sportType = _ref2.sportType,
    startTime = _ref2.startTime,
    results = _ref2.results,
    matchId = _ref2.matchId,
    productId = _ref2.productId,
    eventNumber = _ref2.eventNumber,
    sportEventStatus = _ref2.sportEventStatus,
    statusTime = _ref2.statusTime,
    className = _ref2.className;
  const _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    liveResults = _useState2[0],
    setLiveResults = _useState2[1];
  const _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    liveStatusTime = _useState4[0],
    setLiveStatusTime = _useState4[1];
  const _useState5 = useState(undefined),
    _useState6 = _slicedToArray(_useState5, 2),
    liveSportEventStatus = _useState6[0],
    setLiveSportEventStatus = _useState6[1];
  const handleSocketUpdate = useCallback(result => {
    const error = result.error,
      sportEvent = result.sportEvent;
    if (!error) {
      const currentResult = helpers.getCurrentResult(sportEvent.results);
      setLiveResults(currentResult || {
        home: '0',
        away: '0'
      });
      setLiveStatusTime(sportEvent.statusTime);
      setLiveSportEventStatus(sportEvent.status);
    } else {
      logger.error("Error in socket subscription for sportevent ".concat(matchId, ": ").concat(error));
    }
  }, [matchId]);
  const isLive = matchState === SportinfoMatchState.Ongoing;
  const isNotStarted = matchState === SportinfoMatchState.NotStarted;
  const isFulltraff = productId && productId === productIds.FULLTRAFF;
  const oddsLable = odds => odds || '-';
  return React.createElement("div", {
    className: "sportinfo-bigstat-banner ".concat(className ? className : '')
  }, isLive && React.createElement(LiveDataSubscriber, {
    matchId: matchId,
    onUpdate: handleSocketUpdate,
    path: "/sport/1/sportevent/".concat(matchId),
    productId: productId
  }), onCloseClick && React.createElement(IconButton, {
    className: "close-btn",
    onClick: onCloseClick
  }, React.createElement(Icon, {
    color: "fc-navy",
    icon: "close",
    size: "200"
  })), leagueName && React.createElement("div", {
    className: "sport-name f-content p f-capitalize"
  }, "".concat(SportTypeToString[sportType], ", ").concat(leagueName)), React.createElement(MatchHeader, {
    awayTeam: awayTeam,
    eventNumber: eventNumber,
    homeTeam: homeTeam,
    matchState: matchState,
    results: isLive ? liveResults : results
  }), odds && isNotStarted && !isFulltraff && React.createElement("div", {
    className: "f-content p odds"
  }, "1: ".concat(oddsLable(odds.one), " X: ").concat(oddsLable(odds.x), " 2: ").concat(oddsLable(odds.two))), React.createElement(MatchProgress, {
    matchState: matchState,
    sportEventStatus: isLive ? liveSportEventStatus : sportEventStatus,
    sportType: sportType,
    startTime: startTime,
    statusTime: isLive ? liveStatusTime : statusTime
  }));
};
setGlobal('svs.components.sportInfo.bigStatBanner.BigStatBanner', BigStatBanner);

 })(window);